// src/pages/Appointments/config/appointmentsMenuConfig.js

import {
  CalendarIcon,
  ClockIcon,
  CheckCircleIcon,
  UserAddIcon,
  ChartBarIcon,
  ClipboardListIcon,
  ExclamationCircleIcon,
  PlayIcon,
} from "@heroicons/react/outline";
import { FiCalendar, FiUsers, FiActivity, FiClock } from "react-icons/fi";
import {
  APPOINTMENT_ROUTES,
  APPOINTMENT_PERMISSIONS,
} from "../constants/appointments.constant";

// ========================================
// APPOINTMENTS MENU GROUP
// ========================================
export const APPOINTMENTS_MENU_GROUP = {
  id: "appointments",
  translationKey: "menu.groups.appointments",
  icon: CalendarIcon,
  color: {
    bg: "bg-teal-500",
    hover: "hover:bg-teal-600",
    light: "bg-teal-50",
    text: "text-teal-600",
    border: "border-teal-500",
  },
  expanded: false,
  featureFlag: "appointments",
  items: [
    {
      path: APPOINTMENT_ROUTES.DASHBOARD,
      translationKey: "menu.items.appointments_dashboard",
      descriptionKey: "menu.descriptions.appointments_dashboard",
      icon: FiCalendar,
      permissions: [APPOINTMENT_PERMISSIONS.VIEW_APPOINTMENTS, "ADMIN"],
      featureFlag: "appointmentsDashboard",
      badge: { type: "info", count: 0 }, // Today's appointments count
    },
    {
      path: APPOINTMENT_ROUTES.BOOK,
      translationKey: "menu.items.book_appointment",
      descriptionKey: "menu.descriptions.book_appointment",
      icon: UserAddIcon,
      permissions: [APPOINTMENT_PERMISSIONS.CREATE_APPOINTMENTS, "ADMIN"],
      featureFlag: "bookAppointment",
    },
    // {
    //   path: APPOINTMENT_ROUTES.CALENDAR,
    //   translationKey: "menu.items.appointment_calendar",
    //   descriptionKey: "menu.descriptions.appointment_calendar",
    //   icon: CalendarIcon,
    //   permissions: [APPOINTMENT_PERMISSIONS.VIEW_APPOINTMENTS],
    //   featureFlag: "appointmentCalendar",
    // },
    {
      path: APPOINTMENT_ROUTES.TODAY,
      translationKey: "menu.items.todays_appointments",
      descriptionKey: "menu.descriptions.todays_appointments",
      icon: ClockIcon,
      permissions: [APPOINTMENT_PERMISSIONS.VIEW_APPOINTMENTS],
      featureFlag: "todaysAppointments",
      badge: { type: "warning", count: 0 }, // Dynamic count
    },
    // {
    //   path: APPOINTMENT_ROUTES.UPCOMING,
    //   translationKey: "menu.items.upcoming_appointments",
    //   descriptionKey: "menu.descriptions.upcoming_appointments",
    //   icon: FiClock,
    //   permissions: [APPOINTMENT_PERMISSIONS.VIEW_APPOINTMENTS],
    //   featureFlag: "upcomingAppointments",
    // },
    {
      path: APPOINTMENT_ROUTES.ACTIVE_VISITS,
      translationKey: "menu.items.active_visits",
      descriptionKey: "menu.descriptions.active_visits",
      icon: FiActivity,
      permissions: [APPOINTMENT_PERMISSIONS.TRACK_VISITS],
      featureFlag: "activeVisits",
      badge: { type: "success", count: 0 }, // Currently active
    },
    {
      path: APPOINTMENT_ROUTES.PENDING,
      translationKey: "menu.items.pending_approvals",
      descriptionKey: "menu.descriptions.pending_approvals",
      icon: ExclamationCircleIcon,
      permissions: [APPOINTMENT_PERMISSIONS.APPROVE_APPOINTMENTS, "ADMIN"],
      featureFlag: "pendingApprovals",
      badge: { type: "warning", count: 0 },
    },
    // {
    //   path: APPOINTMENT_ROUTES.LIST,
    //   translationKey: "menu.items.all_appointments",
    //   descriptionKey: "menu.descriptions.all_appointments",
    //   icon: ClipboardListIcon,
    //   permissions: [APPOINTMENT_PERMISSIONS.VIEW_APPOINTMENTS],
    //   featureFlag: "allAppointments",
    // },
    {
      path: APPOINTMENT_ROUTES.ANALYTICS,
      translationKey: "menu.items.appointment_analytics",
      descriptionKey: "menu.descriptions.appointment_analytics",
      icon: ChartBarIcon,
      permissions: [APPOINTMENT_PERMISSIONS.VIEW_ANALYTICS, "ADMIN"],
      featureFlag: "appointmentAnalytics",
    },
  ],
};

// ========================================
// QUICK ACCESS ITEMS FOR APPOINTMENTS
// ========================================
export const APPOINTMENTS_QUICK_ACCESS = [
  //   {
  //     path: APPOINTMENT_ROUTES.BOOK,
  //     translationKey: "menu.quick_access.book_appointment",
  //     icon: UserAddIcon,
  //     color: "bg-gradient-to-r from-teal-500 to-cyan-600",
  //     permissions: [APPOINTMENT_PERMISSIONS.CREATE_APPOINTMENTS],
  //     isSpecial: true,
  //     featureFlag: "quickAccessBookAppointment",
  //   },
  //   {
  //     path: APPOINTMENT_ROUTES.TODAY,
  //     translationKey: "menu.quick_access.todays_appointments",
  //     icon: ClockIcon,
  //     color: "bg-gradient-to-r from-orange-500 to-amber-600",
  //     permissions: [APPOINTMENT_PERMISSIONS.VIEW_APPOINTMENTS],
  //     isSpecial: true,
  //     featureFlag: "quickAccessTodayAppointments",
  //     badge: { type: "warning", dynamic: true },
  //   },
];
